export default {
  en: {
    DELETE_BUYER_MODAL_TITLE: 'Delete Buyer',
    BUYER_ACTIONS_SHOW_REFERENCES: 'Show References',

    BUYER_ADD_BUTTON: 'Create',
    BUYER_ALLOW_DISPUTE_CONVERSION_TT:
      'Enable to allow the Buyer to dispute call conversions',
    BUYER_ALLOW_DISPUTE_CONVERSION: 'Allow Buyer To Dispute Call Conversions',
    BUYER_ALLOW_PAUSE_TARGET_TT:
      'Enable to allow invited Buyers to pause their Targets via the portal.',
    BUYER_ALLOW_PAUSE_TARGET: 'Allow Buyer To Pause Targets',
    BUYER_ALLOW_SET_TARGET_CONCURRENCY_TT:
      'Enable to allow invited Buyers to set the concurrency and call caps of their Targets via the portal.',
    BUYER_ALLOW_SET_TARGET_CONCURRENCY: 'Allow Buyer To Set Target Caps',
    BUYER_CAN_DISPUTE_CONVERSION_HINT: 'Can Dispute Conversions',
    BUYER_CAN_DISPUTE_CONVERSION: 'Yes',
    BUYER_CAN_NOT_DISPUTE_CONVERSION: 'No',
    BUYER_CAN_NOT_PAUSE_TARGETS: 'No',
    BUYER_CAN_NOT_SET_CONCURRENCY_CAPS_TARGETS: 'No',
    BUYER_CAN_PAUSE_TARGETS_HINT: 'Can Pause Targets',
    BUYER_CAN_PAUSE_TARGETS: 'Yes',
    BUYER_CAN_SET_CONCURRENCY_CAPS_TARGETS: 'Yes',
    BUYER_CAN_SET_TARGET_CONCURRENCY_HINT:
      'Can Set Target Call and Concurrency Caps',
    BUYER_ID: 'Buyer ID',
    BUYER_COMPANY_DEFAULT: 'Ringba',
    BUYER_COMPANY_NAME: 'Company Name',
    BUYER_COMPANY_TT: "Enter your Buyer's company name.",
    BUYER_COMPANY: 'Company',
    BUYER_CREATE_SUCCESS: 'Buyer added. Email invite sent.',
    BUYER_EDIT_SUCCESS: 'Buyer updated.',
    BUYER_EMAIL_ADDRESS_DEFAULT: 'support@ringba.com',
    BUYER_EMAIL_ADDRESS_TT:
      'This email will be used for notifications and forgotten passwords.',
    BUYER_EMAIL_ADDRESS: 'Email Address',
    BUYER_EMAIL_CONFIRM_DEFAULT: 'support@ringba.com',
    BUYER_EMAIL_CONFIRM_TT: "Confirm your Buyer's email address.",
    BUYER_EMAIL_CONFIRM: 'Confirm Email',
    BUYER_EMAIL: 'Email',
    BUYER_FIRST_NAME_DEFAULT: 'John',
    BUYER_FIRST_NAME_TT: "Enter your Buyer's first name.",
    BUYER_FIRST_NAME: 'First Name',
    BUYER_HAS_CAPS_TT: 'Set caps to revenue based conversion amount',
    BUYER_HAS_CAPS: 'Limit Revenue',
    BUYER_HEADER_LOADING: 'Loading Buyer Details.',
    BUYER_HEADER_TASK_CALL: 'Buyer',
    BUYER_INVALID_COMPANY_NAME: 'Please enter the company name',
    BUYER_INVALID_CONFIRM_EMAIL: 'This does not match the above email address',
    BUYER_INVALID_EMAIL: 'Looks like there is a typo in your email address.',
    BUYER_INVALID_FIRST_NAME: 'Please enter first name',
    BUYER_INVALID_LAST_NAME: 'Please enter last name',
    BUYER_INVALID_REQUIRE_EMAIL: 'Please enter email',
    BUYER_LAST_NAME_DEFAULT: 'Smith',
    BUYER_LAST_NAME_TT: "Enter your Buyer's last name.",
    BUYER_LAST_NAME: 'Last Name',
    BUYER_NOTICE_CREATE: 'Buyer Created.',
    BUYER_NOTICE_UPDATE: 'Buyer Updated.',
    BUYER_SHOW_ALL: 'Show All Buyers',
    BUYER_SUBID_DEFAULT: ' ',
    BUYER_SUBID_TT: "Enter your Buyer's tracking subid.",
    BUYER_SUBID: 'Sub Id',
    BUYERS_ACTIONS_EDIT: 'Edit Buyer',
    BUYERS_ADD_BUTTON: 'Create Buyer',
    BUYERS_DELETE: 'Delete Buyer',
    BUYERS_HEADER_LOADING: 'Loading Buyers.',
    BUYERS_HEADER_NONE: 'You have not created any Buyers.',
    BUYERS_HEADER: 'Manage Buyers',
    BUYER_REFERENCES_TABLE_TYPE: 'Type',
    BUYER_REFERENCES_TABLE_NAME: 'Name', 
    BUYER_REFERENCES_TABLE_ID: 'Id',
    BUYER_REFERENCES_TITLE: 'Buyer References',
    BUYER_REFERENCES_LOADING: 'Loading buyer references...',
    BUYER_REFERENCES_EMPTY: 'No references found for this buyer',
    BUYERS_SEARCH_PH: 'Search Buyer',
    BUYERS_STATUS_CAPPED: 'Buyer Capped',
    BUYERS_STATUS_CC_HIT: 'Buyer has hit the concurrency Cap',
    BUYERS_STATUS_CLOSED: 'Closed',
    BUYERS_STATUS_DISABLED: 'Disabled',
    BUYERS_STATUS_OPEN: 'Open',
    BUYER_DUPLICATE_RESTRICTION: 'Restrict Duplicates',
    BUYER_DUPLICATE_RESTRICTION_TT:
      'Restrict Duplicate calls received on the targets of this buyer',
    BUYER_DUPLICATE_RESTRICTION_DURATION: 'Duration',
    BUYER_DUPLICATE_RESTRICTION_DURATION_COLUMN: 'Restriction Duration',
    BUYER_DUPLICATE_RESTRICTION_CONDITION_COLUMN: 'Restriction Condition',
    BUYER_DUPLICATE_RESTRICTION_DURATION_INVALID:
      'Days must be greater than 0 and less than or equal to 365',
    BUYER_DUPLICATE_RESTRICTION_DURATION_TT:
      'How long the duplicates should be blocked after the last connected or converted call',
    BUYER_DUPLICATE_RESTRICTION_DURATION_TIME_LIMIT: 'Time Limit',
    BUYER_DUPLICATE_RESTRICTION_CONDITION: 'Restrict After',
    BUYER_DUPLICATE_RESTRICTION_CONDITION_TT:
      'If toggled, only previously converted and connected calls will be used for restricting duplicate calls.',
    BUYER_DUPLICATE_RESTRICTION_POPOVER_ALWAYS:
      'Always restrict {previousState} duplicate calls {restrictionText}',
    BUYER_DUPLICATE_RESTRICTION_POPOVER_LIMITED:
      'Restrict {previousState} duplicate calls for {days} days {restrictionText}',
    BUYER_DUPLICATE_RESTRICTION_POPOVER_NONE: 'No restriction',
    LABEL_DELETE_CONFIRMATION_MESSAGE:
      'Are you sure you want to delete?</br></br><strong>{name}</strong> is currently associated with the following items:',
    MANAGE_USER_INVITES: 'Manage Invites',
    DELETE_BUYER_MODAL_ASSOCIATION_TEXT:
      'Are you sure you want to delete this buyer?</br></br><strong>{buyerName}</strong> is currently associated with the following items:',
    DELETE_BUYER_MODAL_CHECK_ASSOCIATION_ERROR_TEXT:
      'An error occurred while determining associated targets or users, please try again.',
    DELETE_BUYER_MODAL_CHECK_ASSOCIATION_TEXT:
      'Determining if <strong>{buyerName}</strong> is currently associated with any targets or users.',
    DELETE_BUYER_MODAL_NONE_ASSOCIATION_TEXT:
      '<strong>{buyerName}</strong> is not associated with any targets or users.',
    DELETE_BUYER_MODAL_VIEW_TARGET: 'View Target',
    DELETE_BUYER_SUCCESSFUL_MESSAGE: 'Buyer Deleted',
    INVALID_FORM: 'Please fill out required or invalid fields and try again',
    DIAL_SETTINGS_REVENUE_RECOVERY_BUYER_TT: 'Choose whether to send revenue recovery calls to this buyer\'s targets. You can enable or disable revenue recovery calls, or you can use the default revenue recovery setting on the campaign. ',
  }
};
